<template>
	<div @click="resetToolbar" class="titleBlock" v-if="(selectedRoom) || title" >
		<v-layout column class="px-4">
			<v-layout v-if="title" class="px-4 py-3 body-1" >
				<span style="width:vh100; margin: auto;">{{title}}</span>
			</v-layout>
			<v-layout row class="px-4 py-3 body-1" justify-space-between v-if="selectedRoom && !title">
				<v-flex xs9 class="text-truncate">
		  			{{selectedBuilding && selectedBuilding.name}} ({{selectedBuilding && selectedBuilding.bldgAlpha}})
		  		</v-flex>
		  		<v-flex class="pr-2" style="text-align: right;">
		  			{{selectedRoom && selectedRoom.number}}
		  		</v-flex>
		  		<v-flex v-if="$vuetify.breakpoint.xsOnly" 
		  			style="text-align: right; opacity: .6; position: relative; top: -2px;" >
		  			<v-btn dark small icon @click.stop="" :href="baseURL + selectedBuilding.bldgAlpha + '/' + selectedRoom.number" target="_blank">
		  				<v-icon small >open_in_full</v-icon>
		  			</v-btn>			        
		    	</v-flex>
		  	</v-layout>	

		</v-layout>	
	</div>

	<!-- OFFLINK BUTTON	<a @click.stop="" :href="baseURL + selectedBuilding.bldgAlpha + '/' + selectedRoom.number" target="_blank"><img :src="require('../assets/offlink.jpg')" height="15px" /></a> -->

	<!-- URL DISPLAY <v-flex class="px-1 body-1" v-if="devMode" style="text-align: center;">
		<a :href=url @click.stop="" target="_blank">{{url}}</a>
	</v-flex> -->

</template>

<script>

import { loadModules } from 'esri-loader'
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {

	computed: {
		...mapState({	selectedBuilding: state => state.space.selectedBuilding,
						selectedRoom: state => state.space.selectedRoom,
						mapReady: state => state.ui.mapReady,	
						baseURL: state => state.ui.baseURL,					
					}),

		url() {
			return this.baseURL + this.selectedBuilding.bldgAlpha + '/' + this.selectedRoom.number
		},

		devMode() {
			//console.log("DevMode Check")
			//console.log(this.$route.path)
	    	if (this.$route.path.includes('dev')) {
	    		//console.log("dev")
	    		return true
	    	}

	    },

	    title() {
	    	return this.$route.query.title
	    },
	},


	methods: {
		...mapMutations(['setSelectedRoom', 'setShowToolbar', 'setSelectedBuilding', ]),
		...mapActions(['clearGraphics']),

		resetToolbar() {
	        //this.setSelectedBuilding(null)
	        //this.setSelectedRoom(null)
	        //console.log("Reset Toolbar")
	        this.setShowToolbar(true)
	        if (this.$route.path.includes('dev')) {
	        	this.$router.push({ name: "devMode", params: { bldg: null, room: null } }) 
	        } else {
	        	this.$router.push({ name: "highlightRoom", params: { bldg: null, room: null } })         
	        }

	        this.clearGraphics()			
	    },


		
	}
}

</script>

<style>
.titleBlock {
	position: fixed;
	z-index: 3;
	width: 100%;
	background-color: #333333;
	color: white;
	border-radius: 0px; 
	border-style: solid; 
	border-width: 0px; 
	border-bottom-width: 1px; 
	border-color: #00000050;
}

/*.titleBlock a:link {
	color: white !important;
}

.titleBlock a:visited {
	color: white !important;
}

.titleBlock a:hover {
	color: #FFAAAA  !important;
}

.titleBlock a:active {
	color: white !important;
}*/

</style>
